<template>
  <!-- 首页 -->
  <div>
    <Banner></Banner>
    <AuctionProcess></AuctionProcess>
    <!-- <RecentAuctions></RecentAuctions> -->
    <!-- <AuctionVehicles /> -->
     <!-- 招标需要 -->
      <CallForBidsInfo></CallForBidsInfo>

  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Header from "@/components/Home/header";
import Banner from "./Banner/index.vue";
import Footer from "@/components/Home/footer";
import CallForBidsInfo from "./callForBidsInfo/index.vue";
import AuctionProcess from "@/components/Home/auctionProcess";
import AuctionVehicles from "@/components/Home/auctionVehicles";
import RecentAuctions from "@/components/Home/recentAuctions";
export default {
  name: "HomeView",
  components: {
    Header,
    Banner,
    Footer,
    AuctionProcess,
    AuctionVehicles,
    RecentAuctions,
    CallForBidsInfo
  },
};
</script>

<style lang="less" scoped>
</style>